import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

//Components
import { Modal, ModalBody, ModalFooter, Button, Tooltip, Form, Input } from "@gpstrackit/react-controls";
import Accordion from "Components/Accordion";
import { NotificationManager } from 'Components/Notifications';
import CustomCard from 'Components/Card';
import { Grid, Chip } from "@mui/material";
import Alert from '@mui/material/Alert';

import { HasPermission } from 'Core/security';
import { getBadget } from 'Core/data/Helpers';

//Actions
import {
    firmwareAssignGetFirmwareRequest,
    firmwareAssignGetDeviceRequest,
    firmwareAssignSetDevices,
    firmwareAssignFirmwareRequest,
    searchEntityRequest,
    generateValidationCode,
    clearRedux,
} from 'Redux/actions';

const AssignFirmware = (props) => {
    const dispatch = useDispatch();
    const formRef = useRef(null);
    const { messages } = useIntl();

    const [serial, setSerial] = useState("");
    let [applyScopes, setApplyScopes] = useState(["Partial"]);
    let [verificationCode, setVerificationCode] = useState("");
    let applyScopesItems = [
        { key: "Partial", permissionKey: null, label: "Partial" },
        { key: "Default", permissionKey: "vftcsd", label: "Default" },
        { key: "All", permissionKey: "vftcsa", label: "All" },
    ]
    const [codeSent, setCodeSent] = useState(false);

    const {
        openModal,
        loading,
        device,
        devices,
        firmware,
        current,
        result
    } = useSelector(state => state.assignFirmwareRedux);
    const manufacturers = useSelector(state => state.generalRedux.manufacturers);
    const firmwares = useSelector(state => state.generalRedux.firmwares);
    const { loadingVfCode, VfCodeResult } = useSelector(state => state.commonRedux);
    const user = useSelector(state => state.securityRedux.user);

    const closeModal = () => {
        dispatch(clearRedux("ASSIGN_FIRMWARE"));
        setSerial("");
        setApplyScopes(["Partial"]);
        dispatch(clearRedux("ASSIGN_FIRMWARE", { devices: [] }));
        setCodeSent(false);
    }

    const searchDevice = () => {
        if (serial) {
            if (devices.length > 0) {
                let serialValidation = devices.some((item) => item?.esn === serial || item?.imei === serial)
                if (!serialValidation) {
                    dispatch(firmwareAssignGetDeviceRequest(serial?.trim()));
                } else {
                    NotificationManager.warning(
                        messages['assign_firmware_the_device_is_already_added'],
                        messages['assign_firmware_title'],
                        3000
                    );
                }
            } else dispatch(firmwareAssignGetDeviceRequest(serial?.trim()));
        }
    }

    const applyChanges = () => {
        let payload = {
            verificationCode: verificationCode
        }
        
        payload.firmwareUpdateGroups = [{
            firmwareId: +firmware?.firmwareId,
            hardwareVersion: firmware?.hardwareVersion,
            scopes: applyScopes,
            unitIds: devices?.map((item) => (item.id)) || [],
        }]
        dispatch(firmwareAssignFirmwareRequest(payload));
    }

    useEffect(() => {
        if (openModal && current) {
            dispatch(firmwareAssignGetFirmwareRequest(current))
            dispatch(clearRedux("ASSIGN_FIRMWARE", { current: null }));
        }
        if (device) {
            if (device.total) {
                let newDevice = device.items[0];
                let manufacturerValidation = newDevice?.deviceModel?.manufacturer?.name === "VidFleet";
                if (manufacturerValidation) {
                    setSerial("");
                    let hardwareVersionValidation = newDevice?.unitConfig?.hardwareVersion === firmware?.hardwareVersion;
                    if (hardwareVersionValidation) {

                        let selected = firmwares.find(x => x.version === newDevice?.unitConfig?.firmwareId)

                        let firmwareValidation = false
                        if (selected?.firmwareId)
                            firmwareValidation = (_.parseInt(selected.firmwareId) > _.parseInt(firmware?.firmwareId))

                        if (!firmwareValidation) {
                            let currenDevices = devices
                            currenDevices.push(newDevice);
                            setSerial("");
                            dispatch(firmwareAssignSetDevices(currenDevices));
                        } else {
                            NotificationManager.error(
                                messages['assign_firmware_of_device_is_higher'],
                                messages['assign_firmware_title'],
                                3000
                            );
                        }
                    } else {
                        NotificationManager.error(
                            messages['assign_firmware_hardware_version_not_valid'],
                            messages['assign_firmware_title'],
                            3000
                        );
                    }
                } else {
                    NotificationManager.error(
                        messages['assign_firmware_the_device_manu_must_be_vidfleet'],
                        messages['assign_firmware_title'],
                        3000
                    );
                }
            } else {
                NotificationManager.error(
                    messages['assign_firmware_no_device_found'],
                    messages['assign_firmware_title'],
                    3000
                );
            }
            dispatch(clearRedux("ASSIGN_FIRMWARE", { device: null }));
        }
        if (result) {
            dispatch(clearRedux("ASSIGN_FIRMWARE", { result: null }));
            if (!result.error) {
                let resultValidation = result.includes("true") || result.includes("stepFunctionId");
                if (resultValidation) {
                    NotificationManager.success(
                        messages['assign_firmware_the_firmware_was_assigned'],
                        messages['assign_firmware_title'],
                        3000
                    );
                    closeModal();
                    //refresh the list
                    props?.tableRef && props?.tableRef?.current?.getData();
                } else {
                    NotificationManager.error(
                        messages['assign_firmware_unable_to_update_fimware'],
                        messages['assign_firmware_title'],
                        3000
                    );
                }
                setCodeSent(false);
            } else {
                let message = messages["assign_firmware_unable_to_update_fimware"]
                if (result.error && result.error.error) {
                    if (messages[result.error.error])
                        message = messages[result.error.error]
                    else
                        message = result.error.error.replace("Bad request ->", "").replace("GraphQL error: ", "")
                }

                //Error message
                NotificationManager.error(
                    messages["assign_firmware_title"],
                    message,
                    3000,
                    null,
                    null,
                    'error'
                );
                setCodeSent(false);
            }
        }

        if (VfCodeResult) {
            dispatch(clearRedux("COMMON", { VfCodeResult: null }));
            if (!VfCodeResult.error) {
                if (VfCodeResult.result) {
                    NotificationManager.success(
                        '',
                        messages["vidfleet_configuration_vf_code_sent"],
                        3000,
                        null,
                        null,
                        'success'
                    );
                } else {
                    //Error message
                    NotificationManager.error(
                        messages["assign_firmware_title"],
                        messages["vidfleet_configuration_vf_code_error"],
                        3000,
                        null,
                        null,
                        'error'
                    );
                }
            } else {
                //Error message
                NotificationManager.error(
                    messages["assign_firmware_title"],
                    messages["vidfleet_configuration_vf_code_error"],
                    3000,
                    null,
                    null,
                    'error'
                );
            }
            //message verification code send
        }
    }, [current, device, result, VfCodeResult]);

    useEffect(() => {
        (!manufacturers || manufacturers?.length === 0) && dispatch(searchEntityRequest({ key: "manufacturers" }));
        (!firmwares || firmwares?.length === 0) && dispatch(searchEntityRequest({ key: "firmwares" }));
    }, []);

    return (
        <Modal
            open={openModal}
            title={messages['assign_firmware_title']}
            loading={loading || loadingVfCode}
            position="right"
            size="small"
            handleClose={() => closeModal()}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 35 }}>
                    <Accordion
                        title={messages['assign_firmware_firmware_details']}
                        defaultIsOpen
                    >
                        <Grid container style={{ width: '100%' }}>
                            <Grid item xs={4}>
                                <div style={{ display: 'grid', marginTop: 4 }}>
                                    <span style={{ fontWeight: 700 }}>{messages['assign_firmware_Id']}</span>
                                    <span>{firmware?.firmwareId}</span>
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <div style={{ display: 'grid', marginTop: 4 }}>
                                    <span style={{ fontWeight: 700 }}>{messages['assign_firmware_hardware_version']}</span>
                                    <span>{firmware?.hardwareVersion}</span>
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <div style={{ display: 'grid', marginTop: 4 }}>
                                    <span style={{ fontWeight: 700 }}>{messages['assign_firmware_firmware_version']}</span>
                                    <span>{firmware?.version}</span>
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <div style={{ display: 'grid', marginTop: 4 }}>
                                    <span style={{ fontWeight: 700 }}>{messages['assign_firmware_firmware_type']}</span>
                                    <span>{firmware?.build}</span>
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <div style={{ display: 'grid', marginTop: 4 }}>
                                    <span style={{ fontWeight: 700 }}>{messages['assign_firmware_status']}</span>
                                    <span>{firmware?.isActive ? messages['firmware_tab_active'] : messages['firmware_tab_deactivated']}</span>
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <div style={{ display: 'grid', marginTop: 4 }}>
                                    <span style={{ fontWeight: 700 }}>{messages['assign_firmware_default']}</span>
                                    <span>{firmware?.isDefault ? messages['firmware_tab_yes'] : messages['firmware_tab_no']}</span>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ display: 'grid', marginTop: 4 }}>
                                    <span style={{ fontWeight: 700 }}>{messages['assign_firmware_file']}</span>
                                    {firmware?.fileUrl &&
                                        <Tooltip title={firmware?.fileUrl}>
                                            <div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                                                {firmware?.fileUrl}
                                            </div>
                                        </Tooltip>
                                    }
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <div style={{ display: 'grid', marginTop: 4 }}>
                                    <span style={{ fontWeight: 700 }}>{messages['assign_firmware_description']}</span>
                                    {
                                        firmware?.description && firmware?.description.length > 100 &&
                                        <Tooltip title={firmware?.description}>
                                            <div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                                                {firmware?.description.substring(0, 100)}
                                            </div>
                                        </Tooltip>
                                    }
                                    {
                                        firmware?.description && firmware?.description.length <= 100 &&
                                        <span>{firmware?.description}</span>
                                    }
                                </div>
                            </Grid>
                        </Grid>
                    </Accordion>
                    <Grid style={{ marginTop: 10 }} container>
                        <div>
                            <label style={{ width: '100%' }} className="input-normal-label">{messages['assign_firmware_apply_scopes']}</label>
                            {
                                applyScopesItems.map((item) => {
                                    if (HasPermission(user, item.permissionKey) || item.permissionKey === null) {
                                        return (
                                            <div className="d-sm-inline-block mb-1" key={`apply-scopes-${item.key}`} style={{ marginLeft: `${item.key !== "Partial" ? "10px" : "0px"}` }}>
                                                <div
                                                    onClick={e => {
                                                        let applyScps = applyScopes;
                                                        if (applyScps.includes(item.key)) {
                                                            applyScps.splice(applyScps.indexOf(item.key), 1);
                                                        } else if (item.key === "Partial") {
                                                            applyScps = ["Partial"];
                                                        } else {
                                                            if (applyScps.includes("Partial") && item.key != "Partial") {
                                                                applyScps.splice(applyScps.indexOf("Partial"), 1);
                                                            }
                                                            applyScps.push(item.key);
                                                        }
                                                        setApplyScopes([...applyScps]);
                                                    }}
                                                >
                                                    {
                                                        getBadget(item.label, applyScopes.includes(item.key))
                                                    }
                                                </div>
                                            </div>
                                        )
                                    }
                                })
                            }
                        </div>
                        <Grid item xs={12} style={{ marginTop: 10 }}>
                            {
                                applyScopes.includes("Partial") &&
                                <Alert severity="info">
                                    <span>{messages["assign_firmware_partial_message"]}</span>
                                </Alert>
                            }
                            {
                                applyScopes.includes("Default") &&
                                <Alert severity="error">
                                    <span>{messages["assign_firmware_default_message"]}</span>
                                </Alert>

                            }
                            {
                                applyScopes.includes("All") &&
                                <Alert style={{ marginTop: 3 }} severity="error">
                                    <span>{messages["assign_firmware_all_message"]}</span>
                                </Alert>

                            }
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 10 }}>
                            {
                                applyScopes.includes("All") && !firmware?.isDefault && !applyScopes.includes("Default") &&
                                <span style={{ color: 'red' }}>{messages['assign_firmware_all_error']}</span>
                            }
                        </Grid>
                        {
                            (applyScopes.includes("Default") || applyScopes.includes("All")) && !codeSent &&
                            <Grid xs={12} style={{ marginTop: 20 }}>
                                <a className="btn-link align-middle" onClick={() => {
                                    //to send the verification code
                                    let manufacturer = manufacturers.find(x => x?.name?.toUpperCase() === "VidFleet".toUpperCase())
                                    dispatch(generateValidationCode("updateVidFleetAssignFirmware", "VidFleet", manufacturer?.id))
                                    setCodeSent(true);
                                }}>
                                    {messages["vidfleet_configuration_send_verification_code"]}
                                </a>
                            </Grid>
                        }
                        {
                            (applyScopes.includes("Default") || applyScopes.includes("All")) &&
                            <Grid xs={12} style={{ marginTop: 20 }}>
                                <Input
                                    type="text"
                                    label={messages['vidfleet_configuration_verification_code']}
                                    placeholder={messages['vidfleet_configuration_verification_code']}
                                    value={verificationCode || ""}
                                    autoComplete="off"
                                    onChange={(value) => setVerificationCode(value?.trim())}
                                    requiredMessage={messages['required_field']}
                                    required
                                    maxLength={20}
                                />
                            </Grid>
                        }
                    </Grid>
                    {applyScopes.includes("Partial") &&
                        <>
                            <Grid
                                style={{ marginTop: 10 }}
                                container
                                spacing={1}
                            >
                                <Grid item xs={10}>
                                    <Form
                                        ref={formRef}
                                        onValidSubmit={() => searchDevice()}
                                    >
                                        <Input
                                            label={messages['assign_firmware_imei_or_serial']}
                                            placeholder={messages['assign_firmware_imei_or_serial']}
                                            value={serial}
                                            required
                                            requiredMessage={messages['required_field']}
                                            onChange={(value) => setSerial(value)}
                                        />
                                    </Form>
                                </Grid>
                                <Grid item xs={2}>
                                    <div style={{ marginTop: 26 }}>
                                        <Button
                                            className="btn-dark-blue"
                                            onClick={() => formRef?.current?.submit()}
                                        >
                                            {messages['common_add']}
                                        </Button>
                                    </div>
                                </Grid>
                            </Grid>
                            {devices?.length > 0 ? devices.map((item, index) => {
                                return (
                                    <CustomCard
                                        key={index}
                                        onClick={() => {
                                            let currentDevices = devices;
                                            let selected = currentDevices.findIndex((device) => device.id === item.id);
                                            if (selected > -1) currentDevices.splice(selected, 1);
                                            dispatch(firmwareAssignSetDevices(currentDevices));
                                        }}
                                    >
                                        <div style={{ display: 'grid' }}>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['assign_firmware_imei']}</label><span>{item.imei}</span>
                                            </div>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['assign_firmware_serial']}</label><span>{item.esn}</span>
                                            </div>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['assign_firmware_hardware_version']}</label><span>{item?.unitConfig?.hardwareVersion}</span>
                                            </div>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['assign_firmware_current_firmware']}</label><span>{item?.unitConfig?.firmwareId}</span>
                                            </div>
                                        </div>
                                    </CustomCard>
                                )
                            }) : <div style={{ display: 'flex', justifyContent: 'center', marginTop: 25 }} ><span style={{ opacity: 0.6 }} >{messages['common_no_devices_added']}</span></div>}
                        </>
                    }
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    disabled={
                        applyScopes.length === 0 ||
                        (applyScopes.includes("Partial") && devices.length === 0) ||
                        (applyScopes.includes("All") && !firmware?.isDefault && !applyScopes.includes("Default")) ||
                        ((applyScopes.includes("Default") || (applyScopes.includes("All") && !firmware?.isDefault)) && verificationCode === "")
                    }
                    className="btn-dark-blue"
                    onClick={() => applyChanges()}
                >
                    {messages['assign_firmware_apply']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default AssignFirmware